import {Component, Input, OnInit} from '@angular/core';
import {PageNames} from '../page-names.enum';
import {NavigationService} from '../../services/navigation/navigation.service';
import {NotSelectableNavigationItem} from '../../model/not-selectable-navigation-item';

@Component({
  selector: 'app-overlay-message',
  templateUrl: './overlay-message.component.html',
  styleUrls: ['./overlay-message.component.less']
})
export class OverlayMessageComponent extends NotSelectableNavigationItem implements OnInit {

  @Input()
  hasPackageAlready: boolean;
  @Input()
  isDowngrade: boolean;
  @Input()
  hasDayPass: boolean;
  @Input()
  hasTrial: boolean;

  constructor(private navigationService: NavigationService) {
    super();
  }

  ngOnInit(): void {
    this.navigationService.registerNavigation(this, PageNames.DETAIL_PAGE_ORDER_OPTIONS);
  }
}
